<!-- shopy Head -->
<div class="loader_session" *ngIf='loaderdata'>
  <div class="loader-4"><span></span>
</div>
</div>

<div
  class="collecting-header"
  style="background-image: url(assets/image/Group-1895.png);">
  <div class="collecting-head">
    <div class="head">
      <h3>COLLECTING BASICS</h3>
    </div>
  </div>
</div>

<!-- collections details -->
<div class="container">
    <div class="row my-4">
        <div class="col-md-6">
            <div class="images">
                <img src="{{data[0]?.art_image}}">

            </div>
        
        </div>
        <div class="col-md-6 header_data">
            <!-- <p>{{data[0]?.art_date}}</p> -->
            <h4>{{data[0]?.art_head}}</h4>
            
        </div>
    </div>
    <div class="my-5 details" [innerHTML]="detaildata">
       
    </div>
   
</div>

<app-contactform></app-contactform>